import { LoaderFunctionArgs } from "react-router-dom";
import { adminManageCoursesInDetailLoaderDTO } from "../types/adminManageCoursesInDetailTypes";
import { PublishStatusEnum } from "../enums/publishStatusEnum";
import { apiEndpoints } from "@/services/api/api";

const statusStringToEnum: Record<string, number> = {
  draft: PublishStatusEnum.Draft,
  published: PublishStatusEnum.Published,
  archived: PublishStatusEnum.Archived,
};

export const adminManageCoursesInDetailLoader = async ({
  request,
}: LoaderFunctionArgs): Promise<adminManageCoursesInDetailLoaderDTO> => {
  const url = new URL(request.url);
  const page = Number(url.searchParams.get("page") ?? 1);
  const search = url.searchParams.get("search") ?? "";
  const statusParam = url.searchParams.get("publishStatus") ?? "all";
  const publishStatus = statusStringToEnum[statusParam] ?? null;

  void page;
  void search;
  void publishStatus;

  const response = await apiEndpoints.adminGetAllCourses({
    pageNumber: page,
    pageSize: 10,
    search: search || null,
    publishStatus,
  });
  if (!response.success) {
    throw new Error(response.message);
  }
  return response.data;
};
